import ColorField from "../../../components/Form/ColorField";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_PAINT_SETTINGS,
  TEMPLATES_PRESETS,
  TEMPLATES_SHADOW,
  TEMPLATES_SHADOW_ANGLE,
  TEMPLATES_SHADOW_BLUR,
  TEMPLATES_SHADOW_DISTANCE,
  TEMPLATES_SHADOW_PRESET_GLOW,
  TEMPLATES_SHADOW_PRESET_HARD,
  TEMPLATES_SHADOW_PRESET_LIFT,
  TEMPLATES_SHADOW_PRESET_SOFT,
} from "../../../i18n/keysTranslations";
import PaintMetricSettings from "./PaintMetricSettings";

const optionalRules = { required: false };
const SHADOW_ANGLE_SLIDER_MAX = 360;
const SHADOW_DISTANCE_SLIDER_MAX = 60;
const SHADOW_BLUR_SLIDER_MAX = 60;

const SHADOW_PRESET_VALUES = [
  {
    id: "soft",
    labelKey: TEMPLATES_SHADOW_PRESET_SOFT,
    values: { shadowAngle: 90, shadowDistance: 4, shadowBlur: 10 },
    previewShadow: "0 2px 4px rgba(0,0,0,0.45)",
  },
  {
    id: "lift",
    labelKey: TEMPLATES_SHADOW_PRESET_LIFT,
    values: { shadowAngle: 90, shadowDistance: 12, shadowBlur: 20 },
    previewShadow: "0 5px 8px rgba(0,0,0,0.45)",
  },
  {
    id: "hard",
    labelKey: TEMPLATES_SHADOW_PRESET_HARD,
    values: { shadowAngle: 45, shadowDistance: 6, shadowBlur: 0 },
    previewShadow: "1.5px 1.5px 0 #6b7280",
  },
  {
    id: "glow",
    labelKey: TEMPLATES_SHADOW_PRESET_GLOW,
    values: { shadowAngle: 0, shadowDistance: 0, shadowBlur: 24 },
    previewShadow: "0 0 8px rgba(0,0,0,0.8)",
  },
];

const TextShadowFields = ({
  control,
  errors,
  disabled = false,
  onChangeField,
}) => {
  const { t } = useTranslationApp();

  return (
    <ColorField
      control={control}
      errors={errors}
      name="shadowColor"
      label={t(TEMPLATES_SHADOW)}
      fullWidth
      disabled={disabled}
      rules={optionalRules}
      actionsChange={(value) => onChangeField({ key: "shadowColor", value })}
      trailing={
        <PaintMetricSettings
          control={control}
          errors={errors}
          disabled={disabled}
          ariaLabel={t(TEMPLATES_PAINT_SETTINGS)}
          presetsLabel={t(TEMPLATES_PRESETS)}
          presets={SHADOW_PRESET_VALUES.map((preset) => ({
            ...preset,
            label: t(preset.labelKey),
          }))}
          fields={[
            {
              name: "shadowAngle",
              label: t(TEMPLATES_SHADOW_ANGLE),
              sliderMax: SHADOW_ANGLE_SLIDER_MAX,
              onChangeField,
            },
            {
              name: "shadowDistance",
              label: t(TEMPLATES_SHADOW_DISTANCE),
              sliderMax: SHADOW_DISTANCE_SLIDER_MAX,
              onChangeField,
            },
            {
              name: "shadowBlur",
              label: t(TEMPLATES_SHADOW_BLUR),
              sliderMax: SHADOW_BLUR_SLIDER_MAX,
              onChangeField,
            },
          ]}
        />
      }
    />
  );
};

export default TextShadowFields;
